<div
    class="agpr-chartBlock agpr-contextMenu-parent"
    [ngClass]="{'agpr-chartBlock--wide': wide, 'agpr-chartBlock--tall': tall}"
    [id]="id + '_dashboard_coverage_summary_chartBlock'"
    [attr.aria-label]="displayElement?.title + ' Chart. ' + ('Reports.chart.keyboardNavigationDescription' | localize)"
>
    <div
        class="agpr-block-content agpr-chartBlock-content agpr-dashboardCoverageSummary"
    >
        <div
            *ngIf="!renderable"
            class='agpr-block-placeholder'
        >
            <span
                class="fa agpr-block-placeholderIcon {{ block.type.icon }}"
                aria-hidden="true"
            ></span>
            <span class="agpr-block-placeholderLabel">{{ block.type.label | localize }}</span>
        </div>
        <div
            *ngIf="preview && series"
            class="agpr-chartBlock-watermark"
        >
            {{ 'Reports.chart.sampleData' | localize }}
        </div>
        <div
            *ngIf="!preview"
            class="agpr-chartBlock-dragHandle"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Reports.chart.dragHandle.ariaLabel' | localize"
            (keydown)="dragKeydown($event)"
        ></div>
        <ul
            class="agpr-contextMenu top right"
            [id]="id + '_dashboard_coverage_summary_chart_actionIcons'"
            role="menu"
        >
            <li role="menuitem">
                <agpr-button
                    [style]="buttonTypes.contextMenu"
                    icon="fa-regular fa-duotone fa-trash-can"
                    [tooltip]="'Dashboard.confirmDialog.deleteChart.button' | localize"
                    (click)="doAction($event, 'delete')"
                >
                </agpr-button>
            </li>
            <li role="menuitem">
                <agpr-button
                    [style]="buttonTypes.contextMenu"
                    icon="fa-regular fa-duotone fa-pen"
                    [tooltip]="'Dashboard.chartSettingsDialog.editChart' | localize"
                    (click)="doAction($event, 'edit')"
                >
                </agpr-button>
            </li>
        </ul>
        <!-- the metadata only renders when the chart fails to get data, otherwise metadata is rendered via amcharts -->
        <div
            class="agpr-coverageSummaryChart-metadata"
        >
            <div
                *ngIf="displayElement?.chartHeaderSettings?.title"
                class="agpr-chartBlockMetadata-title"
            >
                <label>{{ displayElement?.title }}</label>
            </div>
            <div
                *ngIf="displayElement?.chartHeaderSettings?.dateRange || displayElement?.chartHeaderSettings?.sourceLink"
                class="agpr-chartBlockMetadata-subtitleGroup"
                [ngClass]="{'noTitle': !displayElement?.chartHeaderSettings.title}"
            >
                <div
                    *ngIf="displayElement?.chartHeaderSettings?.dateRange"
                    class="agpr-chartBlockMetadata-dateRange"
                    [pTooltip]="displayElement?.dateRangeLabel"
                >
                    {{ displayElement?.dateRangeLabel }}
                </div>
                <a
                    *ngIf="displayElement?.chartHeaderSettings?.sourceLink"
                    class="agpr-chartBlockMetadata-source agpr-chartBlockMetadata-sourceLink"
                    [ngClass]="{'noDate': !displayElement?.chartHeaderSettings.dateRange}"
                    target="_blank"
                    [routerLink]="sourceRouterLink"
                    [queryParams]="sourceRouterLinkQueryParams"
                    [pTooltip]="series && series[0] ? series[0].label : ''"
                >
                    {{ series && series[0] ? series[0].label : '' }}
                </a>
            </div>
        </div>
        <div
            class="agpr-coverageSummaryChart-container"
            [ngClass]="{'noHeader': noHeader}"
        >
            <agpr-data-list-chart
                #dataListChart
                *ngIf="series && chartOptions"
                [series]="series"
                [colors]="displayElement?.styles?.colorMap"
                [responsive]="true"
                [chartOptions]="chartOptions"
                (dataChange)="changeDetectorRef.detectChanges()"
            ></agpr-data-list-chart>
            <agpr-message
                *ngIf="!series && preview"
                [severity]="messageSeverityEnum.info"
            >
                {{ 'Reports.chart.noDataSource' | localize }}
            </agpr-message>
            <agpr-message
                *ngIf="!series && !preview"
                [severity]="messageSeverityEnum.error"
            >
                {{ 'Reports.error.folderRemoved' | localize }}
            </agpr-message>
        </div>
    </div>
    <!-- resize icons -->
    <div class="gridster-item-resize gridster-item-resize--right">
        <span
            class="gridster-item-icon--bottomRight fa-kit fa-agpr-resize-diagonal"
            role="img"
            [attr.aria-label]="'Dashboard.chart.resizeChart'"
        ></span>
    </div>
    <div
        class="agpr-block-hoverBorder"
    >
    </div>
</div>

<div *ngIf="block.errors?.length > 0" class="agpr-blockError">
    <agpr-form-message
        *ngFor="let error of block.errors"
    >
        {{ error }}
    </agpr-form-message>
</div>
